import { render, staticRenderFns } from "./SelectorLugarCobranza.vue?vue&type=template&id=9435b46a&scoped=true"
import script from "./SelectorLugarCobranza.vue?vue&type=script&lang=js"
export * from "./SelectorLugarCobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9435b46a",
  null
  
)

export default component.exports